import { t } from "@/translations"

export default function OrderSummaryTitle({
    langCode,
    itemCount
}: {
    langCode: string
    itemCount: number
}) {
    return (
        <h2 className="flex items-center gap-8 px-12 py-20 Trim_Mono_POC_Text_18_130_-3_500_uppercase sm:px-16 md:border-b md:border-col-border md:px-24 md:py-32">
            {t(langCode, "checkout.order_summary.order_summary")}{" "}
            <span className="pt-3 Trade_Gothic_Text_14_150_0_300">({itemCount})</span>
        </h2>
    )
}
